import React from "react";
import ReviewsCarousel from "./ReviewsCarousel";

const Reviews = () => {
  return (
    <div id="reviews" className="reviews reviews-info">
      <h1>Reviews</h1>
      <div className="container">
        <div className="reviews-content">
          <ReviewsCarousel />
        </div>
      </div>
    </div>
  );
};

export default Reviews;
